//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../src/lib/date';

export default {
    name: "serveMsg",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            list: [],
        }
    },
    methods: {
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Content/GetContentByNodeName?name=' + '便民信息').then((res) => {
                this.list = [];
                this.list.push(...res.data.result);
            });
        },
        // getGraphicInformationByBusiness(id) {
        //     abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + id + '&businessType=content.remarks').then(res => {
        //         this.content = [];
        //         this.content = res.data.result;
        //         // console.log(res.data);
        //     })
        // },
        listClicked(list) {
            this.$router.push('/serveMsgDetail/' + list.id);
        },
    },
    created() {
        this.getContentByNodeName();
    }
}
